import { render, staticRenderFns } from "./TabDocumentos.vue?vue&type=template&id=3c46158b&scoped=true&"
import script from "./TabDocumentos.vue?vue&type=script&lang=js&"
export * from "./TabDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./TabDocumentos.vue?vue&type=style&index=0&id=3c46158b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46158b",
  null
  
)

export default component.exports